<template>
  <div class="meta-wrapper fill-height">
    <div class="save-wrapper">
      <!-- <save-button label="Save"/> -->
    </div>
    <v-fade-transition group>
      <div v-if="slide && slide.flows && slide.flows.length" key="flow" class="box px-2">
        <assignment-card :assignments="slide.flows" document-key="flows" title="Integrated in Flow" />
      </div>
      <div v-if="slide && slide.chapters && slide.chapters.length" key="chapter" class="box px-2">
        <assignment-card
          :assignments="slide.chapters"
          document-key="chapters"
          title="Integrated in Chapter"
        />
      </div>
      <div key="additional" class="box px-2 py-2">
        <core-input
          v-if="slide"
          :is-loading="isLoading['keyMessage']"
          label="Key Message"
          :value="slide.keyMessage"
          :init-value="slide.keyMessage"
          :prepend-icon="icons.key"
          placeholder="Key Message"
          @input="e => onInput(e, 'keyMessage')"
        />
        <core-input
          v-if="slide"
          :is-loading="isLoading['zinc']"
          label="Zinc"
          :value="slide.zinc"
          :init-value="slide.zinc"
          :prepend-icon="icons.zinc"
          placeholder="Zinc"
          @input="e => onInput(e, 'zinc')"
        />
      </div>
      <div key="note" class="box px-2">
        <note-component />
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import icons from '../../mixins/icons';
import AssignmentCardVue from './AssignmentCard.vue';
import CoreInputVue from '../core/inputs/CoreInput.vue';
import NoteComponentVue from '../note/NoteComponent.vue';
export default {
  name: 'AssetMetaDataList',
  components: {
    assignmentCard: AssignmentCardVue,
    coreInput: CoreInputVue,
    noteComponent: NoteComponentVue
  },
  mixins: [icons],
  props: {
    slide: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFlowOpen: false,
      isChapterOpen: false,
      isLoading: {}
    };
  },
  methods: {
    async onInput(val, key) {
      if (val === '') return;
      // this.$store.commit('navigation/showSaveButton');
      this.$store.commit('slides/updateSlide', { key, val });
      this.isLoading[key] = true;

      switch (key) {
        case 'keyMessage':
          if (val === null) {
            val = '';
          }
          await this.$store.dispatch('slides/updateActiveSlide', { [key]: val });
          break;
        case 'zinc':
          if (val === null) {
            val = '';
          }
          await this.$store.dispatch('slides/updateZinc', val);
          break;
        default:
          break;
      }
      this.isLoading[key] = false;
    }
  }
};
</script>

<style scoped>
.box:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.meta-wrapper {
  position: absolute;
  width: 100%;
}
</style>
